import React, { useState } from "react";
import leftgrey from '../../assets/icons/leftgrey.svg';
import leftblack from '../../assets/icons/leftblack.svg';
import rightgrey from '../../assets/icons/rightgrey.svg';
import rightblack from '../../assets/icons/rightblack.svg';
import upright from '../../assets/icons/upright.svg';

import bgnext from '../../assets/images/gallery/bgnext2.jpg';
import afrofusion from '../../assets/images/gallery/friendzonelome-photo-49.jpg';
import detty from '../../assets/images/gallery/friendzonelome-19.jpg';
import lawoman from '../../assets/images/gallery/lafriendzonelome-photo-2.jpg';
import blackpower from '../../assets/images/gallery/lafriendzonelome-photos-juillet-2021-001.jpg';
import afrocelestia from '../../assets/images/gallery/afrocelestia.jpg';

const PhotoGallery = () => {
    const photos = [
        {
            id: 0,
            src: afrocelestia,
            date: "16.08.2025",
            link: "https://lafriendzone.pixieset.com/afrocelestia/",
            theme: "Afro Celestia"
        },
        {
            id: 1,
            src: bgnext,
            date: "27.07.2024",
            link: "https://lafriendzone.pixieset.com/lafriendzone-selfloveclub/",
            theme: "Self Love Club"
        },
        {
            id: 2,
            src: afrofusion,
            date: "20.08.2022",
            link: "https://lafriendzone.pixieset.com/afrofusionedition/",
            theme: "Afrofusion"
        },
        {
            id: 3,
            src: detty,
            date: "16.07.2022",
            link: "https://lafriendzone.pixieset.com/dettyyourselfedition/",
            theme: "Detty Yourself"
        },
        // Ajoute plus d'images ici selon le besoin
        {
            id: 4,
            src: lawoman,
            date: "26.03.2022",
            link: "https://lafriendzone.pixieset.com/lafriendzonelome-lawoman-edition/",
            theme: "LaWoman"
        },
        {
            id: 5,
            src: blackpower,
            date: "31.07.2021",
            link: "https://lafriendzone.pixieset.com/lafriendzonelome-blackpower-edition/",
            theme: "Black Power"
        },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        if (currentIndex < photos.length - 3) { // -3 pour permettre de toujours afficher trois images
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <>
            <section className="xl:flex hidden flex-col lg:gap-[25px] gap-[12px] font-chido relative">

                <div className="flex justify-between items-center">
                    <p className="lg:text-[65px] text-[24px] font-chido">PHOTO GALLERY</p>

                    <div className="flex items-center lg:gap-5 gap-2.5">
                        <span onClick={handlePrevious} className={`cursor-pointer ${currentIndex === 0 ? 'opacity-50' : ''}`}>
                            <img src={currentIndex === 0 ? leftgrey : leftblack} alt="left arrow" />
                        </span>
                        <span onClick={handleNext} className={`cursor-pointer ${currentIndex === photos.length - 3 ? 'opacity-50' : ''}`}>
                            <img src={currentIndex === photos.length - 3 ? rightgrey : rightblack} alt="right arrow" />
                        </span>
                    </div>
                </div>

                <div className="relative flex items-center justify-center">
                    <div className="overflow-hidden w-full grid grid-flow-col overflow-x-auto">
                        <div
                            className="flex lg:gap-[25px] gap-2.5 transition-transform duration-500 ease-in-out"
                            style={{ transform: `translateX(-${currentIndex * 30}%)` }}
                        >
                            {photos.map((photo) => (
                                <div key={photo.id} className="lg:w-[30%] w-[60%] md:w-[30%] flex-shrink-0 group transition-all duration-300 ease-in-out">
                                    <div className="flex flex-col lg:gap-5 gap-2.5 overflow-hidden">
                                        <a href={photo.link} target="_blank" rel="noreferrer">
                                            <div
                                                style={{ backgroundImage: `url(${photo.src})` }}
                                                className="w-full h-[300px] lg:h-[500px] bg-cover bg-center lg:border-[6px] border-[4px] lg:rounded-[20px] rounded-[5px] border-offblack"
                                            >
                                                {/* Opacité utilisée pour créer la transition visible */}
                                                <div className="opacity-0 group-hover:opacity-100 flex justify-center items-center w-full h-full bg-offblack bg-opacity-40 transition-opacity duration-300 ease-in-out">
                                                    <div className="flex justify-center items-center gap-2.5 lg:text-[38px] text-[20px] text-offwhite transition-all duration-300 ease-in-out">
                                                        VOIR
                                                        <img className='lg:-mt-2.5 -mt-1 w-2 lg:w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out' src={upright} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                        <div className="lg:w-full h-[2px] bg-offblack "></div>
                                        <p className="lg:text-[25px] text-[16px]">{photo.theme} - {photo.date}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="xl:hidden h-fit flex flex-col gap-[30px] xl:w-full xl:max-w-[1440px]" >

                <div className="flex justify-between items-center">
                    <h2 className="lg:text-[65px] text-[16px] font-chido">PHOTO GALLERY</h2>
                </div>

                <div className="grid grid-flow-col overflow-x-auto max-w-[100%] gap-[50px]">

                    <div className="flex lg:gap-[25px] gap-[50px] h-fit transition-transform duration-500 ease-in-out">

                        {photos.map((photo) => (
                            <div key={photo.id} className="w-[250px]">
                                <div className="flex flex-col justify-start lg:gap-5 gap-2.5 overflow-x-hidden">
                                    <a href={photo.link} target="_blank" rel="noreferrer">
                                        <div
                                            style={{ backgroundImage: `url(${photo.src})` }}
                                            className="w-full h-[300px] lg:h-[500px] bg-cover bg-center lg:border-[6px] border-[4px] lg:rounded-[20px] rounded-[5px] border-offblack"
                                        />
                                    </a>

                                    <div className="lg:w-full h-[2px] bg-offblack "></div>

                                    <p className="lg:pl-10 pl-5 lg:text-[25px] text-[16px] font-chido">{photo.theme} - {photo.date}</p>
                                </div>
                            </div>
                        ))}

                    </div>

                </div>

            </section>

        </>
    );
};

export default PhotoGallery;
